import * as yup from "yup";
import { getUrlRegex } from "../helper-functions";

const urlRegex = getUrlRegex();

const getUrlMessage = (v: string) => {
    return v + " is not a valid url.";
};

const ConfigSchema = yup.object({
    APP_NAME: yup.string().required(),
    BASE_URL: yup.string().required().matches(urlRegex, getUrlMessage("BASE_URL")),
    API_BASE_URL: yup.string().required().matches(urlRegex, getUrlMessage("API_BASE_URL")),
    REMEMBER_DAYS: yup.number().required(),
    SSO_REDIRECT_URL: yup.string().required().matches(urlRegex, getUrlMessage("SSO_REDIRECT_URL")),
    SSO_CLIENT_ID: yup.string().trim().required("SSO_CLIENT_ID is required"),
    SSO_SCOPE: yup.string().trim().required("SSO_SCOPE is required"),
    GOOGLE_CLIENT_ID: yup.string().optional(),
    AUTO_LOGOUT_ON_IDLE_MINUTES: yup.number().required(),
    DYMO_URL: yup.string().optional().matches(urlRegex, getUrlMessage("DYMO_URL")),
    SHOW_CREATE_DONOR_AND_TISSUES: yup.boolean().required(),
});

export const config = ConfigSchema.validateSync({
    APP_NAME: import.meta.env.VITE_APP_NAME,
    BASE_URL: import.meta.env.VITE_BASE_URL,
    API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    REMEMBER_DAYS: import.meta.env.VITE_REMEMBER_DAYS,
    SSO_REDIRECT_URL: import.meta.env.VITE_SSO_REDIRECT_URL,
    SSO_CLIENT_ID: import.meta.env.VITE_SSO_CLIENT_ID,
    SSO_SCOPE: import.meta.env.VITE_SSO_SCOPE,
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    AUTO_LOGOUT_ON_IDLE_MINUTES: import.meta.env.VITE_AUTO_LOGOUT_ON_IDLE_MINUTES,
    DYMO_URL: import.meta.env.VITE_DYMO_URL,
    SHOW_CREATE_DONOR_AND_TISSUES: import.meta.env.VITE_SHOW_CREATE_DONOR_AND_TISSUES,
});
